import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { lazyGovern, GovernPriority } from 'owa-tti';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "TriageAction"*/ './lazyIndex'),
    { name: 'TriageAction' }
);

export const lazyAddEmailAddressesToSafeSenders: LazyAction<
    typeof lazyIndex.addEmailAddressesToSafeSenders,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addEmailAddressesToSafeSenders);

export const lazyAlwaysMoveRowToFocusedOrOther: LazyAction<
    typeof lazyIndex.alwaysMoveRowToFocusedOrOther,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.alwaysMoveRowToFocusedOrOther);

export const lazyMoveMailListRowsToFocusedOrOther: LazyAction<
    typeof lazyIndex.moveMailListRowsToFocusedOrOther,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.moveMailListRowsToFocusedOrOther);

export const lazyDeleteMailListRows: LazyAction<
    typeof lazyIndex.deleteMailListRows,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.deleteMailListRows);

export const lazyDeleteItems: LazyAction<typeof lazyIndex.deleteItems, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.deleteItems);
export const lazyDeleteConversationsFromConversationActionContexts: LazyAction<
    typeof lazyIndex.deleteConversationsFromConversationActionContexts,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.deleteConversationsFromConversationActionContexts);

export const lazyDeleteItemsWithoutConfirm: LazyAction<
    typeof lazyIndex.deleteItemsWithoutConfirmDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.deleteItemsWithoutConfirmDialog);

export const lazyFlagItems: LazyAction<typeof lazyIndex.flagItems, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.flagItems);

export const lazyDeleteItemsBasedOnNodeOrThreadIds: LazyImport<
    typeof lazyIndex.deleteItemsBasedOnNodeOrThreadIds,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.deleteItemsBasedOnNodeOrThreadIds);

export const lazyRestoreAllItems: LazyAction<typeof lazyIndex.restoreAllItems, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.restoreAllItems);

export const lazyToggleRowsFlagState: LazyAction<
    typeof lazyIndex.toggleRowsFlagState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.toggleRowsFlagState);

export const lazySetMailListRowsFlagState: LazyAction<
    typeof lazyIndex.setMailListRowsFlagState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setMailListRowsFlagState);

export const lazySetItemsFlagStateFromItemIds: LazyAction<
    typeof lazyIndex.setItemsFlagStateFromItemIds,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setItemsFlagStateFromItemIds);

export const lazyMoveMultipleItemsFromItemIds: LazyAction<
    typeof lazyIndex.moveMultipleItemsFromItemIds,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.moveMultipleItemsFromItemIds);
export const lazyMoveConversationsFromConversationIds: LazyAction<
    typeof lazyIndex.moveConversationsFromConversationIds,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.moveConversationsFromConversationIds);
export const lazyMoveItemsBasedOnNodeIds: LazyImport<
    typeof lazyIndex.moveItemsBasedOnNodeIds,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.moveItemsBasedOnNodeIds);
export const lazyMoveItems: LazyImport<typeof lazyIndex.moveItems, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.moveItems);
export const lazyMoveCopyItemCrossMailbox: LazyAction<
    typeof lazyIndex.moveCopyItemCrossMailbox,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.moveCopyItemCrossMailbox);
export const lazyMoveMailListRows: LazyAction<
    typeof lazyIndex.moveMailListRows,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.moveMailListRows);
export const lazyCopyMailListRows: LazyAction<
    typeof lazyIndex.copyMailListRows,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.copyMailListRows);
export const lazyCopyMailListItems: LazyAction<
    typeof lazyIndex.copyMailListItems,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.copyMailListItems);
export const lazyCopyGroupMailListRows: LazyAction<
    typeof lazyIndex.copyGroupMailListRows,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.copyGroupMailListRows);
export const lazyArchiveMailListRows: LazyAction<
    typeof lazyIndex.archiveMailListRowsFromTable,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.archiveMailListRowsFromTable);
export const lazyArchiveMailSingleItem: LazyAction<
    typeof lazyIndex.archiveMailSingleItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.archiveMailSingleItem);
export const lazyScheduleRows: LazyImport<typeof lazyIndex.scheduleRows, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.scheduleRows);
export const lazyScheduleItems: LazyImport<typeof lazyIndex.scheduleItems, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.scheduleItems);
export const lazyScheduleSingleItem: LazyAction<
    typeof lazyIndex.scheduleSingleItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.scheduleSingleItem);
export const lazyToggleRowPinnedState: LazyAction<
    typeof lazyIndex.toggleRowPinnedState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.toggleRowPinnedState);
export const lazyMarkRowsPinnedUnpinned: LazyAction<
    typeof lazyIndex.markRowsPinnedUnpinned,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.markRowsPinnedUnpinned);
export const lazyPinUnpinItems: LazyAction<typeof lazyIndex.pinUnpinItems, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.pinUnpinItems);
export const lazyMarkItemJunkNotJunkFromReadingPane: LazyAction<
    typeof lazyIndex.markItemJunkNotJunkFromReadingPane,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.markItemJunkNotJunkFromReadingPane);

export const lazyOnKeyboardToggleFlagState: LazyAction<
    typeof lazyIndex.onKeyboardToggleFlagState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onKeyboardToggleFlagState);

export const lazyReportItems: LazyAction<typeof lazyIndex.reportItems, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.reportItems);

export const lazyRestoreMailListRowsAction: LazyAction<
    typeof lazyIndex.restoreMailListRows,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.restoreMailListRows);
export const lazyUnsubscribeEmail: LazyAction<
    typeof lazyIndex.unsubscribeEmail,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.unsubscribeEmail);
export const lazyUnsubscribeEmailV2: LazyImport<
    typeof lazyIndex.unsubscribeEmailV2,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.unsubscribeEmailV2);
export const lazyBlockLastSendersFromTable: LazyAction<
    typeof lazyIndex.blockLastSendersFromTable,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.blockLastSendersFromTable);

export const lazyBlockLastSenderFromReadingPane: LazyAction<
    typeof lazyIndex.blockLastSenderFromReadingPane,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.blockLastSenderFromReadingPane);

export const lazyAddSafeSenderFromReadingPane: LazyAction<
    typeof lazyIndex.addSafeSenderFromReadingPane,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addSafeSenderFromReadingPane);

export const lazyAddSafeSenderFromTable: LazyAction<
    typeof lazyIndex.addSafeSenderFromTable,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addSafeSenderFromTable);

export const lazyAddCategoriesFromTable: LazyAction<
    typeof lazyIndex.addCategoriesFromTable,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addCategoriesFromTable);
export const lazyRemoveCategoriesFromTable: LazyAction<
    typeof lazyIndex.removeCategoriesFromTable,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeCategoriesFromTable);
export const lazyClearCategoriesFromTable: LazyAction<
    typeof lazyIndex.clearCategoriesFromTable,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.clearCategoriesFromTable);

export const lazyAddCategoriesFromItem: LazyAction<
    typeof lazyIndex.addCategoriesFromItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addCategoriesFromItem);
export const lazyRemoveCategoriesFromItem: LazyAction<
    typeof lazyIndex.removeCategoriesFromItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeCategoriesFromItem);
export const lazyClearCategoriesFromItem: LazyAction<
    typeof lazyIndex.clearCategoriesFromItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.clearCategoriesFromItem);
export const lazyAddCategoriesFromItems: LazyAction<
    typeof lazyIndex.addCategoriesFromItems,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addCategoriesFromItems);
export const lazyRemoveCategoriesFromItems: LazyAction<
    typeof lazyIndex.removeCategoriesFromItems,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeCategoriesFromItems);
export const lazyClearCategoriesFromItems: LazyAction<
    typeof lazyIndex.clearCategoriesFromItems,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.clearCategoriesFromItems);
export const lazyAddCategoriesFromConversationIds: LazyAction<
    typeof lazyIndex.addCategoriesFromConversationIds,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addCategoriesFromConversationIds);
export const lazyClearCategoriesFromConversationIds: LazyAction<
    typeof lazyIndex.clearCategoriesFromConversationIds,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.clearCategoriesFromConversationIds);

export const lazySweepConversations: LazyAction<
    typeof lazyIndex.sweepConversations,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.sweepConversations);
export const lazyEmptyTableView: LazyAction<typeof lazyIndex.emptyTableView, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.emptyTableView);
export const lazyToggleIgnoreConversations: LazyImport<
    typeof lazyIndex.toggleIgnoreConversations,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.toggleIgnoreConversations);
export const lazyIgnoreConversationItems: LazyAction<
    typeof lazyIndex.ignoreConversationItems,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ignoreConversationItems);
export const lazyIgnoreSingleItem: LazyAction<
    typeof lazyIndex.ignoreSingleItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ignoreSingleItem);
export const lazyMessageRecall: LazyAction<typeof lazyIndex.messageRecall, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.messageRecall);

export const lazyOnRemoveMeeting: LazyImport<typeof lazyIndex.onRemoveMeeting, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.onRemoveMeeting);
export const lazyTranslateFromTable: LazyAction<
    typeof lazyIndex.translateFromTable,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.translateFromTable);
export const lazyLogTriageData: LazyAction<typeof lazyIndex.logTriageData, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.logTriageData);
export const lazyShowNotificationOnSyncMailbox: LazyAction<
    typeof lazyIndex.showNotificationOnSyncMailbox,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showNotificationOnSyncMailbox);
export const lazyTryDismissSyncMailboxNotification: LazyAction<
    typeof lazyIndex.tryDismissSyncMailboxNotification,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.tryDismissSyncMailboxNotification);

export const lazyMoveSingleItemFromItemId: LazyAction<
    typeof lazyIndex.moveSingleItemFromItemId,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.moveSingleItemFromItemId);

export const lazyBlockSenderService: LazyAction<
    typeof lazyIndex.blockSenderService,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.blockSenderService);

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function importAndExecute called at module scope is not allowed. This may cause unwanted side effects. */
lazyGovern.importAndExecute({
    task: () => lazyModule.importModule('prefetchTriageActions'),
    priority: GovernPriority.Messages,
    name: 'prefetchTriageActions',
});

export const lazyApplyCategoryFromCopilotPrompt: LazyAction<
    typeof lazyIndex.applyCategoryFromCopilotPrompt,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.applyCategoryFromCopilotPrompt);

export const lazyPrioritizeAndLabelFolder: LazyAction<
    typeof lazyIndex.prioritizeAndLabelFolder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.prioritizeAndLabelFolder);

export const lazyUpdatePrioritizeScore: LazyAction<
    typeof lazyIndex.updatePrioritizeScore,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updatePrioritizeScore);
